import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Form, Button, Dropdown } from 'semantic-ui-react';
import i18next from 'i18next';
import { saveDashboardUser, editEntityField } from '../../../actions';
import countries from '../../../consts/Countries.json';
import { hasSuperPermission } from '../../../helpers/permissions';

class DashboardUserEditor extends Component {
    handleSubmit = (event) => {
        this.props.saveDashboardUser(this.props.entity);
        event.preventDefault();
    }

    restaurantCapabilitiesOptions = [
        { value: 'menu', text: i18next.t('userPermissions.menu') },
        { value: 'orders', text: i18next.t('userPermissions.orders') },
        { value: 'kiosks', text: i18next.t('userPermissions.kiosks') },
        { value: 'marketing', text: i18next.t('userPermissions.marketing') },
        { value: 'delivery', text: i18next.t('userPermissions.delivery') },
        { value: 'reports', text: i18next.t('userPermissions.reports') },
    ]

    companyCapabilitiesOptions = [
        { value: 'budgets', text: i18next.t('userPermissions.budgets') },
        { value: 'employees', text: i18next.t('userPermissions.employees') },
        { value: 'reports', text: i18next.t('userPermissions.reports') },
    ]

    loyaltyCapabilitiesOptions = [
        { value: 'members', text: i18next.t('userPermissions.members') },
        { value: 'restaurants', text: i18next.t('userPermissions.restaurants') },
        { value: 'campaigns', text: i18next.t('userPermissions.campaigns') },
        { value: 'benefits', text: i18next.t('userPermissions.benefits') },
    ]

    adminCapabilitiesOptions = [
        { value: 'developer', text: i18next.t('userPermissions.developer') },
        { value: 'operation', text: i18next.t('userPermissions.operation') },
        { value: 'panelUsers', text: i18next.t('userPermissions.panelUsers') },
        { value: 'tools', text: i18next.t('userPermissions.tools') },
    ]

    renderRestaurantsOptions({ regionsCodes, posIds, ownersIds: chainsIds, ids, ...rest }) {
        if (regionsCodes) {
            return (
                <Form.Field>
                    <Dropdown
                        fluid
                        search
                        selection
                        multiple
                        placeholder={i18next.t('all')}
                        options={countries.map(country => ({ value: country.alpha_2, text: `${country.alpha_2} - ${country.name}` }))}
                        value={regionsCodes}
                        onChange={(e, { value }) => this.props.editEntityField('permissions.restaurant', { ...rest, regionsCodes: value })}
                    />
                </Form.Field>
            );
        }
        if (posIds) {
            return (
                <Form.Field>
                    <Dropdown
                        fluid
                        search
                        selection
                        multiple
                        placeholder={i18next.t('userPermissions.allPOS')}
                        options={this.props.posSuppliers.map(pos => ({ value: pos.id, text: pos.name }))}
                        value={posIds}
                        onChange={(e, { value }) => this.props.editEntityField('permissions.restaurant', { ...rest, posIds: value })}
                    />
                </Form.Field>
            );
        }
        if (chainsIds) {
            return (
                <Form.Field>
                    <Dropdown
                        fluid
                        search
                        selection
                        multiple
                        placeholder={i18next.t('userPermissions.allChains')}
                        options={this.props.chains.map(chain => ({ value: chain.id, text: chain.name }))}
                        value={chainsIds}
                        onChange={(e, { value }) => this.props.editEntityField('permissions.restaurant', { ...rest, ownersIds: value })}
                    />
                </Form.Field>
            );
        }

        return (
            <Form.Field>
                <Dropdown
                    fluid
                    search
                    selection
                    multiple
                    placeholder={i18next.t('userPermissions.allRestaurants')}
                    options={this.props.restaurants.map((rest) => ({ value: rest.id, text: rest.name }))}
                    value={ids || []}
                    onChange={(e, { value }) => this.props.editEntityField('permissions.restaurant', { ...rest, ids: value.length ? value : undefined })}
                />
            </Form.Field>
        );
    }

    render() {
        if (!this.props.entity) {
            return null;
        }

        const user = this.props.entity || {};

        return (
            <Form onSubmit={this.handleSubmit}>
                <Form.Field>
                    <label>{i18next.t('email')}</label>
                    <input
                        placeholder={i18next.t('email')}
                        value={user.email || ''}
                        type="email"
                        onChange={({ target }) => this.props.editEntityField('email', target.value)}
                        required
                    />
                </Form.Field>

                {user.id ? null :
                    <Form.Field>
                        <label>{i18next.t('password')}</label>
                        <input
                            placeholder={i18next.t('password')}
                            value={user.password || ''}
                            onChange={({ target }) => this.props.editEntityField('password', target.value)}
                            required={!user.id}
                        />
                    </Form.Field>
                }

                <Form.Field>
                    <Form.Group inline>
                        <Form.Checkbox
                            label={i18next.t('userPermissions.restaurant')}
                            checked={!!user.permissions.restaurant}
                            onChange={(e, { checked }) => this.props.editEntityField('permissions.restaurant', checked ? {} : undefined)}
                        />
                        {user.permissions.restaurant ?
                            <Form.Checkbox
                                label={i18next.t('byChains')}
                                checked={!!user.permissions.restaurant.ownersIds}
                                onChange={(e, { checked }) => this.props.editEntityField('permissions.restaurant', { ownersIds: checked ? [] : undefined })}
                            />
                            : null
                        }
                        {user.permissions.restaurant ?
                            <Form.Checkbox
                                label={i18next.t('byPOS')}
                                checked={!!user.permissions.restaurant.posIds}
                                onChange={(e, { checked }) => this.props.editEntityField('permissions.restaurant', { posIds: checked ? [] : undefined })}
                            />
                            : null
                        }
                        {user.permissions.restaurant ?
                            <Form.Checkbox
                                label={i18next.t('byRegion')}
                                checked={!!user.permissions.restaurant.regionsCodes}
                                onChange={(e, { checked }) => this.props.editEntityField('permissions.restaurant', { regionsCodes: checked ? [] : undefined })}
                            />
                            : null
                        }
                    </Form.Group>
                </Form.Field>

                {user.permissions.restaurant && this.renderRestaurantsOptions(user.permissions.restaurant)}

                {user.permissions.restaurant &&
                    <Form.Field>
                        <Dropdown
                            fluid
                            selection
                            multiple
                            options={this.restaurantCapabilitiesOptions}
                            placeholder={i18next.t('userPermissions.capabilities')}
                            value={user.permissions.restaurant.capabilities || []}
                            onChange={(e, { value }) => this.props.editEntityField('permissions.restaurant', { ...user.permissions.restaurant, capabilities: value.length ? value : undefined })}
                        />
                    </Form.Field>
                }

                <Form.Field>
                    <Form.Checkbox
                        label={i18next.t('userPermissions.company')}
                        checked={!!user.permissions.company}
                        onChange={(e, { checked }) => this.props.editEntityField('permissions.company', checked ? {} : undefined)}
                    />
                </Form.Field>

                {user.permissions.company &&
                    <Form.Field>
                        <Dropdown
                            required
                            fluid
                            search
                            selection
                            multiple
                            placeholder={i18next.t('userPermissions.allCompanies')}
                            options={this.props.companies.map((comp) => ({ value: comp.id, text: comp.name }))}
                            value={user.permissions.company.ids || []}
                            onChange={(e, { value }) => this.props.editEntityField('permissions.company', { ...user.permissions.company, ids: value.length ? value : undefined })}
                        />
                    </Form.Field>
                }

                {user.permissions.company &&
                    <Form.Field>
                        <Dropdown
                            fluid
                            selection
                            multiple
                            options={this.companyCapabilitiesOptions}
                            placeholder={i18next.t('userPermissions.capabilities')}
                            value={user.permissions.company.capabilities || []}
                            onChange={(e, { value }) => this.props.editEntityField('permissions.company', { ...user.permissions.company, capabilities: value.length ? value : undefined })}
                        />
                    </Form.Field>
                }

                <Form.Field>
                    <Form.Checkbox
                        label={i18next.t('userPermissions.loyalty')}
                        checked={!!user.permissions.loyalty}
                        onChange={(e, { checked }) => this.props.editEntityField('permissions.loyalty', checked ? {} : undefined)}
                    />
                </Form.Field>

                {user.permissions.loyalty &&
                    <Form.Field>
                        <Dropdown
                            required
                            fluid
                            search
                            selection
                            multiple
                            placeholder={i18next.t('userPermissions.allLoyalties')}
                            options={this.props.loyaltyPrograms.map((comp) => ({ value: comp.id, text: comp.name }))}
                            value={user.permissions.loyalty.ids || []}
                            onChange={(e, { value }) => this.props.editEntityField('permissions.loyalty', { ...user.permissions.loyalty, ids: value.length ? value : undefined })}
                        />
                    </Form.Field>
                }

                {user.permissions.loyalty &&
                    <Form.Field>
                        <Dropdown
                            fluid
                            selection
                            multiple
                            options={this.loyaltyCapabilitiesOptions}
                            placeholder={i18next.t('userPermissions.capabilities')}
                            value={user.permissions.loyalty.capabilities || []}
                            onChange={(e, { value }) => this.props.editEntityField('permissions.loyalty', { ...user.permissions.loyalty, capabilities: value.length ? value : undefined })}
                        />
                    </Form.Field>
                }

                {hasSuperPermission('developer') &&
                    <Form.Field>
                        <Form.Group inline>
                            <Form.Checkbox
                                label={i18next.t('userPermissions.admin')}
                                checked={!!user.permissions.admin}
                                onChange={(e, { checked }) => this.props.editEntityField('permissions.admin', checked ? {} : undefined)}
                            />
                        </Form.Group>
                    </Form.Field>
                }

                {hasSuperPermission('developer') && user.permissions.admin &&
                    <Form.Field>
                        <Dropdown
                            fluid
                            selection
                            multiple
                            options={this.adminCapabilitiesOptions}
                            placeholder={i18next.t('userPermissions.capabilities')}
                            value={user.permissions.admin.capabilities || []}
                            onChange={(e, { value }) => this.props.editEntityField('permissions.admin', { ...user.permissions.admin, capabilities: value.length ? value : undefined })}
                        />
                    </Form.Field>
                }

                <Button primary type='submit' floated="right">
                    {i18next.t('save')}
                </Button>
            </Form>
        );
    }
}

DashboardUserEditor.propTypes = {
    saveDashboardUser: PropTypes.func,
    editEntityField: PropTypes.func,
    companies: PropTypes.array,
    restaurants: PropTypes.array,
    chains: PropTypes.array,
    posSuppliers: PropTypes.array,
    loyaltyPrograms: PropTypes.array,
    entity: PropTypes.object,
    
};

const mapStateToProps = (state) => {
    const { entity } = state.editor;
    const { posSuppliers } = state.meta;
    const { restaurants, chains } = state.businessApp;
    const { companies } = state.budgetsApp;
    const { loyaltyPrograms } = state.loyaltyApp;

    return { entity, companies, restaurants, loyaltyPrograms, chains, posSuppliers };
};

export default connect(mapStateToProps, { saveDashboardUser, editEntityField })(DashboardUserEditor);
